subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      localStorage.setItem('voyado_cart_ref', cart.token);

      if (cart.item_count === 0) {
        va('emptyCart', { cartRef: cart.token });
        return;
      }
      va('cart', {
        cartRef: cart.token,
        // Cart permalink som gjenoppretter varene (variantId:antall) og lander
        // kunden på den fylte handlekurv-siden, uansett enhet/økt - slik at
        // abandoned cart-eposten faktisk fører tilbake til kurven med produktene.
        cartUrl: window.location.origin + '/cart/' + cart.items.map(function (item) {
          return item.variant_id + ':' + item.quantity;
        }).join(',') + '?storefront=true',
        locale: 'nn-NO',
        items: cart.items.map(function (item) {
          return {
            itemId: item.sku,
            quantity: item.quantity,
          };
        }),
      });
    })
    .catch(function (err) {
      console.error('[Voyado] Cart tracking error:', err);
    });
});
